import { AuthenticationModel } from '@/domain/models'
import { Authentication } from '@/domain/usecases'
import { RemoteAuthentication } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import env from '@/main/config/env'

export const makeAuthentication = (): Authentication => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<AuthenticationModel>()

  return new RemoteAuthentication(url, httpClient)
}
